<template>
  <el-tabs v-model="activeName" type="card" @tab-click="handleClick" class="s_tabs_box">
    <el-tab-pane :disabled="!isover" :label="'报名'+'('+signNum01+')'" name="报名" v-if="checkPermission(['tab_signUp'],authLists)"></el-tab-pane>
    <el-tab-pane :disabled="!isover" :label="'待面试'+'('+signNum02+')'" name="待面试" v-if="checkPermission(['tab_interview'],authLists)"></el-tab-pane>
    <el-tab-pane :disabled="!isover" :label="'待入职'+'('+signNum03+')'" name="待入职" v-if="checkPermission(['tab_entry'],authLists)"></el-tab-pane>
    <el-tab-pane :disabled="!isover" :label="'待离职'+'('+signNum08+')'" name="待离职" v-if="checkPermission(['tab_quit'],authLists)"></el-tab-pane>
    <!-- <el-tab-pane :disabled="!isover" :label="'通过'+'('+signNum04+')'" name="通过"></el-tab-pane> -->
    <el-tab-pane :disabled="!isover" :label="'在职'+'('+signNum05+')'" name="在职" v-if="checkPermission(['tab_onJob'],authLists)"></el-tab-pane>
    <el-tab-pane :disabled="!isover" :label="'离职'+'('+signNum07+')'" name="离职" v-if="checkPermission(['tab_resign'],authLists)"></el-tab-pane>
    <el-tab-pane :disabled="!isover" label="全量（在职+离职）" v-if="checkPermission(['tab_all'],authLists)" name="全量"></el-tab-pane>
    <el-tab-pane :disabled="!isover" label="代理招聘" v-if="checkPermission(['tab_PRO'],authLists)" name="代理招聘"></el-tab-pane>
    <el-tab-pane :disabled="!isover" :label="'流程终止'" name="异常" v-if="checkPermission(['tab_end'],authLists)"></el-tab-pane>
  </el-tabs>
</template>
<script>
  import xz from "./../../../common.vue";
  import checkPermission from '@/utils/permission' // 权限判断函数
  export default {
    props: {
      listQuerys: {
        type: Object,
        default () {
          return {}
        }
      },
      btnAuth: {
        type: Array,
        default () {
          return []
        }
      }
    },
    // props:["listQuerys"],
    data() {
      return {
        activeName: '报名',
        isover: true,
        roleType: localStorage.loginRoletype,
        numQuery: {
          StrnowState: '已报名', //状态
          strProjectName: '', // 项目名称
          strUserName: '', // 姓名
          strMobile: '', // 联系方式
          strJobInf: '', //岗位
          strSource: '', //来源
          strreuser: '', //招聘顾问
          strUserkf: '', //客服
          stroutid: '', //导出选中id
          currpage: 1, // 分页
          perpage: 10,
          strSourcejl: '', //简历来源
          posCategoryList: [], //意向岗位
          jobList: [], // 人岗匹配岗位
          roletype: localStorage.loginRoletype
        },
        // 按钮权限列表
        authLists: [],
        noteNum: 0,
        noteCanView: 'fasle',
        signNum01: 0, // 报名数量
        signNum02: 0, // 已约面数量
        signNum03: 0, // 到面数量
        signNum04: 0, // 通过数量
        signNum05: 0, // 在职数量
        signNum06: 0, // 异常数量
        signNum07: 0, // 离职数量
        signNum08: 0 // 待离职数量
      }
    },
    created() {
      // console.log('yy',this.btnAuth)
      if (!this.isNull(this.$route.query.active)) {
        this.activeName = this.$route.query.active
      } else {
        this.activeName = '报名'
      }
      if (!this.isNull(this.$route.query.objName)) {
        this.listQuerys.strProjectName = this.$route.query.objName
      }
      if (!this.isNull(this.$route.query.strUserName)) {
        this.listQuerys.strUserName = this.$route.query.strUserName
      }
      if (!this.isNull(this.$route.query.strMobile)) {
        this.listQuerys.strMobile = this.$route.query.strMobile
      }
      if (this.activeName == '报名') {
        this.listQuerys.StrnowState = '已报名'
      } else if (this.activeName == '已约面') {
        this.listQuerys.StrnowState = '约面'
      } else if (this.activeName == '待面试') {
        this.listQuerys.StrnowState = '待面试'
      } else if (this.activeName == '待入职') {
        this.listQuerys.StrnowState = '待入职'
      } else if (this.activeName == '在职') {
        this.listQuerys.StrnowState = '入职'
      } else if (this.activeName == '异常') {
        this.listQuerys.StrnowState = '未到面,未通过,未入职'
      } else if (this.activeName == '离职') {
        this.listQuerys.StrnowState = '离职'
      } else if (this.activeName == '待离职') {
        this.listQuerys.StrnowState = '待离职'
      }
      if (location.pathname.indexOf('/signupList') > -1) {
        this.numQuery = this.listQuerys
        this.numQuery.currpage = 1
      }
      this.authLists = this.btnAuth
      // this.getNoteNum()
      // this.getSignNum()
      // 向父组件传值
      this.$emit('change', this.activeName);
    },
    watch: {
      '$store.state.resourceComTabsIsover': function () {
        this.isover = this.$store.state.resourceComTabsIsover
        //   console.log('d',this.isover)
      }
    },
    methods: {
      checkPermission,
      // 获取流程数量
      getSignNum() {
        let d = {
          userid: Cookies.get("userid-b"),
          projectid: this.listQuerys.projectid!=undefined && this.listQuerys.projectid!=0 ? this.listQuerys.projectid : '',
          customerJobName: "",
          IdCard: this.listQuerys.strIdCard!=undefined && this.listQuerys.strIdCard ? this.listQuerys.strIdCard : '',
          Name: this.listQuerys.strUserName!=undefined && this.listQuerys.strUserName ? this.listQuerys.strUserName : '',
          Phone: this.listQuerys.strMobile!=undefined && this.listQuerys.strMobile ? this.listQuerys.strMobile : '',
        }
        xz.rcFun(d, 'InterviewOnboarding/GetPeopleNumberData').then(res => {
          if (res.status == 'ok') {
            // console.log('rr',res)
            this.signNum01 = res.data.signcont
            this.signNum02 = res.data.tobeintercont
            this.signNum03 = res.data.tobeentrycont
            this.signNum04 = res.data.adoptcont
            this.signNum05 = res.data.onjobcont
            // this.signNum06 = res.data.abnorcont
            this.signNum07 = res.data.quitcont
            this.signNum08 = res.data.waitquitcont
          }
        })
      },
      // 父组件获取数据
      getCanViewVal() {
        return this.noteCanView
      },
      // 父组件获取数据
      getNumVal() {
        return this.noteNum
      },
      // 获取用户可用短信数量 判断是否有通知权限
      getNoteNum() {
        xz.getsmsavailablenum('', localStorage.loginRoletype).then(res => {
          // console.log('rr',res)
          if (res.status == 'ok') {
            this.noteNum = res.data
            this.noteCanView = 'true'
          } else {
            this.noteNum = 0
            this.noteCanView = 'false'
          }
        })
      },
      handleClick(tab, event) {
        console.log('lq2',this.listQuerys)
        // 向父组件传递值
        this.$emit('change', tab.name);

        const signupListTabs = {
          '报名': '已报名',
          '待面试': '待面试',
          '待入职': '待入职',
          '已约面': '约面',
          '到面': '到面',
          '通过': '通过',
          // '在职': '入职',
          '异常': '未到面,未通过,未入职',
          // '离职': '离职',
          '待离职': '待离职'
        };

        if (signupListTabs[tab.name]) {
          this.listQuerys.StrnowState = signupListTabs[tab.name];
          const query = {
            objName: this.listQuerys.strProjectName,
            projectid:this.listQuerys.projectid,
            strUserName: this.listQuerys.strUserName,
            strMobile: this.listQuerys.strMobile
          };

          // 过滤掉空值
          Object.keys(query).forEach(key => {
            if (this.isNull(query[key])) {
              delete query[key];
            }
          });

          this.$router.push({
            path: `/signupList?active=${tab.name}`,
            query
          });
        } else if (tab.name === '流程记录') {
          this.$router.push({
            path: '/processRecord?active=流程记录'
          });
        } else if (tab.name === '消息通知记录') {
          this.$router.push({
            path: '/noteSendList?active=消息通知记录'
          });
        }
        //  else if (tab.name === '项目列表') {
        //   this.$router.push({
        //     path: '/empRosterList?active=项目列表',
        //     query: {
        //       objName: this.listQuerys.strProjectName
        //     }
        //   });
        // } 
        else if (tab.name === '在职' || tab.name === '离职' || tab.name === '全量') {
          const query = {
            objName: this.listQuerys.strProjectName,
            projectid:this.listQuerys.projectid,
            strUserName: this.listQuerys.strUserName,
            strMobile: this.listQuerys.strMobile
          };

          // 过滤掉空值
          Object.keys(query).forEach(key => {
            if (this.isNull(query[key])) {
              delete query[key];
            }
          });

          this.$router.push({
            path: `/empRosterPerson?active=${tab.name}`,
            query
          });
        } else if (tab.name === '代理招聘') {
          const query = {
            objName: this.listQuerys.strProjectName,
            strUserName: this.listQuerys.strUserName,
            strMobile: this.listQuerys.strMobile
          };

          // 过滤掉空值
          Object.keys(query).forEach(key => {
            if (this.isNull(query[key])) {
              delete query[key];
            }
          });

          this.$router.push({
            path: '/agencyRec?active=代理招聘',
            query
          });
        }

        // 公共逻辑
        this.numQuery = this.listQuerys;
        this.numQuery.currpage = 1;
        this.getSignNum();
      },
      //判断是否为空(包含0)
      isNull(o) {
        return o == undefined || o == "undefined" || (o + '').indexOf("undefined") > -1 || o == null || o == '' || o == 'null' || o == [] || o == 0 || o == 'NaN' || o == ('1900-01-01') || o == '1900-01-01T00:00:00';
      }
    }
  }
</script>